module.exports = __webpack_public_path__ + "static/media/mi.699f852f.svg";